:host {
  display: block;
}

.order-detail__value {
  display: block;
  font-weight: var(--sc-font-weight-semibold);
  line-height: var(--sc-line-height-dense);
}

.order-detail__label {
  display: block;
  color: var(--sc-color-gray-500);
  line-height: var(--sc-line-height-dense);
}
